<template>
  <v-layout class="criterio-select">
    <v-flex class="d-flex" cols="12" sm="6">
      <v-select
        v-model="data"
        :items="values"
        :disabled="disabled"
        item-text="label"
        item-value="id"
        class="input-select default-input"
        hide-details=""
        solo
        @change="input"
      ></v-select>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: {
    values: {
      type: [Array, Number],
      default: () => {
        return {}
      },
    },
    label: String,
    currentIndex: Number,
    currentValue: {
      type: Number,
      default: 0,
    },
    initialValue: Number,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    data: 0,
  }),

  mounted() {
    this.data = this.initialValue
    this.validate()
  },

  methods: {
    input(value) {
      const currentChildren = this.values.find((valueToFind) => {
        return valueToFind.id === value
      })
      this.$emit('input', { currentValue: value, currentChildren, currentIndex: this.currentIndex, affectsChildren: true })

      this.validate()
    },

    validate() {
      this.$emit('validate', { isValid: true, currentIndex: this.currentIndex })
    },
  },
}
</script>

<style lang="scss">
.criterio-select {
  padding: 8px 0;
  .input-select {
    .v-input__slot {
      background-color: #ffffff !important;
    }
  }

  .v-input__control {
    padding: 5px 0;
    min-height: 0 !important;
  }
}
</style>
